import { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { getServices } from "../lib/servicesCache";
import { PackageCard } from "../components/PackageCard";
import { ServiceGridLoading } from "../components/ServiceCardSkeleton";
import { Sparkles } from "lucide-react";
import { PageBackdrop } from "../components/PageBackdrop";

export default function PackagesPage() {
    const [packages, setPackages] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get("/packages", { params: { active_only: true } }).then((r) => r.data),
            getServices(),
        ]).then(([p, s]) => {
            setPackages(p || []);
            setServices(s || []);
        }).catch(() => {}).finally(() => setLoading(false));
    }, []);

    const servicesById = useMemo(() => Object.fromEntries((services || []).map((s) => [s.id, s])), [services]);

    return (
        <div className="relative isolate min-h-screen pt-24 pb-24" data-testid="packages-page">
            <PageBackdrop testid="packages-bg" />
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="mb-14 pt-8 max-w-2xl">
                    <div className="inline-flex items-center gap-2 text-[0.65rem] tracking-[0.28em] uppercase text-[#8F622C]">
                        <Sparkles size={12} /> Special Packages
                    </div>
                    <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#3D0C1F] mt-4">Curated experiences,<br className="hidden sm:block" /> one price.</h1>
                    <p className="text-sm text-[#7A5262] mt-4 max-w-xl leading-relaxed">
                        Save with our thoughtfully bundled experiences — perfect for bridal, anniversaries, or a well-earned day of luxury.
                    </p>
                </div>

                {loading ? (
                    <ServiceGridLoading count={4} headline="Curating your packages" />
                ) : packages.length === 0 ? (
                    <div className="text-center text-[#7A5262] py-20" data-testid="packages-empty">No packages available right now. Check back soon.</div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                        {packages.map((p) => (
                            <PackageCard key={p.id} pkg={p} servicesById={servicesById} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
